import postRoutes from './postRoutes';

export default {
  path: '/posts',
  children: postRoutes,
};



// WEBPACK FOOTER //
// src/routes/posts/index.js